module.exports = __webpack_public_path__ + "static/media/acr-segment-green.3dcc8fe8.svg";